export const DISCORD_URL = "https://discord.com/channels/1532039067498451026/1532039067498451028";
